import { render, staticRenderFns } from "./Quotation_edit.vue?vue&type=template&id=96b735f0&scoped=true&"
import script from "./Quotation_edit.vue?vue&type=script&lang=js&"
export * from "./Quotation_edit.vue?vue&type=script&lang=js&"
import style0 from "./Quotation_edit.vue?vue&type=style&index=0&id=96b735f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b735f0",
  null
  
)

export default component.exports